import { getNewsSectors, getSectorwiseNews, getScripWiseNewsData, getSectorWiseNewsDetails } from "../../apis";
import { NEWS } from "../actionTypes";
import { deepClone } from "../../utils/global_functions";
import {
    _FIIDIIMFData, _announcementsExchange, _bulkBlockDealData, _exchangeAnnouncementsSuccess, _hotPursuitData, _mergerDemergerData,
    _sectorWiseNewsSuccess, _sortHoldingNewsCards
} from "../../controllers";
import { API_ERRORS } from "../../utils/global_variables";



export const updateNewsVisibleScipsAction = (payload = {}) => {
    return { type: NEWS.UPDATE_VISBLE_SCRIP_FOR_SUB_AND_UNSUB, payload };
};

export const newsSectors = (jtenantToken) => async (dispatch) => {
    //   Azeem K : 16-02-2024 :BT-117131 : Breeze Portfolio - Holdings - News – Start 
    dispatch(isNewsApiPending(true));
    //   Azeem K : 16-02-2024 :BT-117131 : Breeze Portfolio - Holdings - News – End 
    try {
        dispatch(fetchNewsSector());
        let objResp = await getNewsSectors(jtenantToken);
        if (objResp.data.ResponseObject.type === "success") {
            dispatch(newsSectorsSuccess(objResp.data.ResponseObject.resultset));
            dispatch(dispatch(updateSectorCode(objResp.data.ResponseObject?.resultset[0]?.SectorCode))); // Hari k:25-01-2024 :Bt-107439 - dashboard news: updating sector code
        } else {
            dispatch(newsSectorsFailure(objResp.data.ResponseObject.errormessage));
        }
    } catch (error) {
        console.log(error.message);
        dispatch(newsSectorsFailure([]));
        //   Azeem K : 16-02-2024 :BT-117131 : Breeze Portfolio - Holdings - News – Start 
    } finally {
        dispatch(isNewsApiPending(false));
    }
    //   Azeem K : 16-02-2024 :BT-117131 : Breeze Portfolio - Holdings - News – End 
};

export const fetchNewsSector = (payload) => {
    return { type: NEWS.GET_NEWS_SECTORS, payload };
};

export const newsSectorsSuccess = (payload) => {
    return { type: NEWS.GET_NEWS_SECTORS_SUCCESS, payload };
};

export const newsSectorsFailure = (payload) => {
    return { type: NEWS.GET_NEWS_SECTORS_FAILURE, payload };
};



export const sectorWiseNews = (sectorCode, page, nItems, jtenantToken) => async (dispatch) => {
    //   Azeem K : 16-02-2024 :BT-117131 : Breeze Portfolio - Holdings - News – Start 
    dispatch(isNewsApiPending(true));
    //   Azeem K : 16-02-2024 :BT-117131 : Breeze Portfolio - Holdings - News – End 
    try {
        dispatch(fetchSectorWiseNews());

        let objResp = await getSectorwiseNews(sectorCode, page, nItems, jtenantToken);
        if (objResp.data.ResponseObject.type === "success") {
            if (objResp.data.ResponseObject.resultset.length) {
                dispatch(sectorWiseNewsSuccess(objResp.data.ResponseObject.resultset));
            } else {
                dispatch(isReachedLimit(true));
                dispatch(sectorWiseNewsFailure());
            }
        } else {
            dispatch(sectorWiseNewsFailure(objResp.data.ResponseObject.errormessage));
        }
    } catch (error) {
        console.log(error.message);
        dispatch(sectorWiseNewsFailure(error.message));
        //   Azeem K : 16-02-2024 :BT-117131 : Breeze Portfolio - Holdings - News – Start 
    } finally {
        dispatch(isNewsApiPending(false));

    }
    //   Azeem K : 16-02-2024 :BT-117131 : Breeze Portfolio - Holdings - News – End 
};

export const clearNewsState = () => async (dispatch) => {
    dispatch(clearNews());
};

export const clearNews = (payload) => {
    return { type: NEWS.CLEAR_NEWS_STATE, payload };
};


export const fetchSectorWiseNews = (payload) => {
    return { type: NEWS.GET_SECTOR_WISE_NEWS, payload };
};

export const sectorWiseNewsSuccess = (payload) => {
    const objResp = _sectorWiseNewsSuccess(payload);
    if (objResp.status) {
        return { type: NEWS.GET_SECTOR_WISE_NEWS_SUCCESS, payload: objResp?.data };
    }
};

export const sectorWiseNewsFailure = (payload) => {
    return { type: NEWS.GET_SECTOR_WISE_NEWS_FAILURE, payload };
};




export const hotPursuitData = (nItems, jtenantToken) => async (dispatch, getState) => {
    //   Azeem K : 16-02-2024 :BT-117131 : Breeze Portfolio - Holdings - News – Start 
    dispatch(isHotPursuitApiPending(true));
    //   Azeem K : 16-02-2024 :BT-117131 : Breeze Portfolio - Holdings - News – End 

    try {
        const holdingsScrips = deepClone(getState().holdings?.holdingsScrips);
        const objResp = await _hotPursuitData(nItems, jtenantToken, holdingsScrips);
        if (objResp?.status) {
            dispatch(hotPursuitDataSuccess(objResp?.data));
        } else {
            dispatch(hotPursuitDataFailure([]));
        }
        //   Azeem K : 16-02-2024 :BT-117131 : Breeze Portfolio - Holdings - News – Start 
    } catch (error) {
        dispatch(hotPursuitDataFailure([]));

    } finally {
        dispatch(isHotPursuitApiPending(false));
    }
    //   Azeem K : 16-02-2024 :BT-117131 : Breeze Portfolio - Holdings - News – End 
};

export const hotPursuitDataSuccess = (payload) => {
    return { type: NEWS.GET_HOT_PURSUIT_NEWS_SUCCESS, payload };
};

export const hotPursuitDataFailure = (payload) => {
    return { type: NEWS.GET_HOT_PURSUIT_NEWS_FAILURE, payload };
};



export const announcementsExchange = (exchange, page, items, jtenantToken) => async (dispatch, getState) => {
    //   Azeem K : 16-02-2024 :BT-117131 : Breeze Portfolio - Holdings - News – Start 
    dispatch(isAnnouncementApiPending(true));
    //   Azeem K : 16-02-2024 :BT-117131 : Breeze Portfolio - Holdings - News – End 
    try {
        const holdingsScrips = deepClone(getState().holdings?.holdingsScrips);
        const objResp = await _announcementsExchange(exchange, page, items, jtenantToken, holdingsScrips);
        if (objResp.data === API_ERRORS.NO_DATA_FOUND) {
            dispatch(isReachedLimit(true));
            dispatch(exchangeAnnouncementsFailure());
        }
        else if (objResp.status) {
            dispatch(exchangeAnnouncementsSuccess(objResp.data));
        } else {
            dispatch(exchangeAnnouncementsFailure([]));
        }
        //   Azeem K : 16-02-2024 :BT-117131 : Breeze Portfolio - Holdings - News – Start 
    } catch (error) {
        dispatch(exchangeAnnouncementsFailure([]));

    } finally {
        dispatch(isAnnouncementApiPending(false));

    }
    //   Azeem K : 16-02-2024 :BT-117131 : Breeze Portfolio - Holdings - News – End 
};

export const exchangeAnnouncementsSuccess = (arrAnnouncements) => {
    const objResp = _exchangeAnnouncementsSuccess(arrAnnouncements);
    if (objResp.status) {
        return { type: NEWS.GET_EXCHANGE_ANNOUNCEMENTS_SUCCESS, payload: objResp?.data };
    }
};


export const updateAnnouncementNewsStatus = (nNewsId) => (dispatch, getState) => {
    const nAnnouncementStatus = deepClone(getState().news?.nAnnouncementStatus);
    let nUpdatedAnnouncementStatus = '';
    if (nAnnouncementStatus === nNewsId) {
        nUpdatedAnnouncementStatus = null;
    } else {
        nUpdatedAnnouncementStatus = nNewsId;
    }
    dispatch(updateAnnouncementNewsStatusSuccess(nUpdatedAnnouncementStatus));
};

export const updateAnnouncementNewsStatusSuccess = (payload) => {
    return { type: NEWS.UPDATE_ANNOUNCEMENT_STATUS, payload };
};

export const updateAnnouncementSuccess = (payload) => {
    return { type: NEWS.GET_EXCHANGE_ANNOUNCEMENTS_SUCCESS, payload };
};

export const isReachedLimit = (payload) => {
    return { type: NEWS.IS_REACHED_LIMIT, payload };
};

export const clearannouncementState = () => async (dispatch) => {
    dispatch(clearannouncement());
};

export const clearannouncement = (payload) => {
    return { type: NEWS.CLEAR_ANNOUNCEMENT_STATE, payload };
};

export const exchangeAnnouncementsFailure = (payload) => {
    return { type: NEWS.GET_EXCHANGE_ANNOUNCEMENTS_FAILURE, payload };
};

export const getNews = () => {
    return { type: NEWS.GET_NEWS, payload: {} };
};

export const updateActiveNews = (activeNews) => {
    return { type: NEWS.UPDATE_ACTIVE_NEWS, payload: activeNews };
};

export const updateActiveNewsTab = (activeTab) => async (dispatch) => {
    dispatch(updateActiveNewsTabSuccess(activeTab));
};

export const updateActiveNewsTabSuccess = (activeTab) => {
    return { type: NEWS.UPDATE_ACTIVE_TAB, payload: activeTab };
};

export const updateSectorCode = (activeTab) => {
    return { type: NEWS.UPDATE_NEWS_SECTOR, payload: activeTab };
};

export const updateAnnouncementType = (activeTab) => {
    return { type: NEWS.UPDATE_ANNOUNCEMENT_TYPE, payload: activeTab };
};

export const updateNewsSearchText = (searchText) => (dispatch) => {
    dispatch(updateSearchTextSuccess(searchText));
};

export const updateSearchTextSuccess = (activeTab) => {
    return { type: NEWS.UPDATE_NEWS_SEARCH_TEXT, payload: activeTab };
};

export const clearNewsaDetailsStates = () => (dispatch) => {
    dispatch(clearNewsaDetailsStatesSuccess());
};

export const clearNewsaDetailsStatesSuccess = (payload) => {
    return { type: NEWS.CLEAR_NEWS_DETAIL_STATES, payload };
};

/*Shuaib P BT-117131 Breeze Portfolio - Holdings - News Start */

export const scripWiseHoldingsNews = (nToken, sExchange, scripNewsPage, jtenantToken) => async (dispatch, getState) => {
    try {
        let objResp = await getScripWiseNewsData(nToken, sExchange, scripNewsPage, jtenantToken);
        let arrPrevNews = deepClone(getState()?.news?.holdingNews);
        if (objResp.data.ResponseObject.type === "success" && objResp.data.ResponseObject.recordcount > 0) {
            let objSingleNews = deepClone(objResp?.data?.ResponseObject?.resultset[0]);
            let sortedNewsArray = _sortHoldingNewsCards({ ...objSingleNews, otherData: objResp?.data?.ResponseObject?.resultset?.slice(1) }, arrPrevNews);
            dispatch(holdingNewsSuccess(sortedNewsArray?.data));
        } else {
            dispatch(holdingNewsFailure(objResp?.data?.ResponseObject?.errormessage));
        }
    }
    catch (error) {
        console.log(error.message);
        dispatch(holdingNewsFailure(error?.message));
    }
};

/*Shuaib P BT-117131 Breeze Portfolio - Holdings - News End */


export const holdingNewsSuccess = (payload) => {
    return { type: NEWS.GET_HOLDINGS_NES_SUCCESS, payload };
};

export const holdingNewsFailure = (payload) => {
    return { type: NEWS.GET_HOLDINGS_NES_FAILURE, payload };
};



export const scripWiseNewsData = (odinCode, sExchange, scripNewsPage, jtenantToken) => async (dispatch) => {
    //   Azeem K : 16-02-2024 :BT-117131 : Breeze Portfolio - Holdings - News – Start 
    dispatch(isSectorWiseNewsDetailsApiPending(true));
    //   Azeem K : 16-02-2024 :BT-117131 : Breeze Portfolio - Holdings - News – End 
    try {
        let objResp = await getScripWiseNewsData(odinCode, sExchange, scripNewsPage, jtenantToken);
        if (objResp.data.ResponseObject.type === "success") {
            dispatch(scripWiseNewsDataSuccess(objResp?.data?.ResponseObject?.resultset));
            dispatch(scripOtherNewsData(objResp?.data?.ResponseObject?.resultset?.slice(1)));
            return Promise.resolve(objResp?.data?.ResponseObject?.resultset);
        } else {
            dispatch(isSectorWiseNewsDetailsApiPending(true));
            dispatch(scripWiseNewsDataFailure(objResp?.data?.ResponseObject?.errormessage));
        }
    }
    catch (error) {
        console.log(error.message);
        dispatch(scripWiseNewsDataFailure(error?.message));
        return Promise.reject(error);
        //   Azeem K : 16-02-2024 :BT-117131 : Breeze Portfolio - Holdings - News – Start 
    } finally {
        dispatch(isSectorWiseNewsDetailsApiPending(false));
        //   Azeem K : 16-02-2024 :BT-117131 : Breeze Portfolio - Holdings - News – End 
    }
};

export const scripWiseNewsDataSuccess = (payload) => {
    return { type: NEWS.GET_HOT_PURSUIT_DETAILS_SUCCESS, payload };
};

export const scripWiseNewsDataFailure = (payload) => {
    return { type: NEWS.GET_HOT_PURSUIT_DETAILS_FAILURE, payload };
};

export const scripOtherNewsData = (payload) => {
    return { type: NEWS.GET_OTHER_NEWS_DATA, payload };
};


export const sectorWiseNewsDetails = (SNo, jtenantToken) => async (dispatch) => {
    //   Azeem K : 16-02-2024 :BT-117131 : Breeze Portfolio - Holdings - News – Start 
    dispatch(isSectorWiseNewsDetailsApiPending(true));
    //   Azeem K : 16-02-2024 :BT-117131 : Breeze Portfolio - Holdings - News – End 
    try {
        let objResp = await getSectorWiseNewsDetails(SNo, jtenantToken);
        if (objResp.data.ResponseObject.type === "success") {
            dispatch(sectorWiseNewsDetailsSuccess(objResp.data.ResponseObject.resultset));
        } else {
            dispatch(sectorWiseNewsDetailsFailure(objResp.data.ResponseObject.errormessage));
        }
    }
    catch (error) {
        console.log(error.message);
        dispatch(sectorWiseNewsDetailsFailure(error.message));
    }
    //   Azeem K : 16-02-2024 :BT-117131 : Breeze Portfolio - Holdings - News – Start 
    finally {
        dispatch(isSectorWiseNewsDetailsApiPending(false));

    }
    //   Azeem K : 16-02-2024 :BT-117131 : Breeze Portfolio - Holdings - News – End 

};
//   Azeem K : 16-02-2024 :BT-117131 : Breeze Portfolio - Holdings - News – Start 
export const isSectorWiseNewsDetailsApiPending = (payload) => {

    return { type: NEWS.IS_SECTORWISE_NEWS_DETAILS_API_PENDING, payload: payload };
};
export const isNewsApiPending = (payload) => {

    return { type: NEWS.IS_NEWS_API_PENDING, payload: payload };
};
export const isHotPursuitApiPending = (payload) => {

    return { type: NEWS.IS_HOTPURSSUIT_API_PENDING, payload: payload };
};
export const isAnnouncementApiPending = (payload) => {

    return { type: NEWS.IS_ANNOUNCEMENT_API_PENDING, payload: payload };
};
//   Azeem K : 16-02-2024 :BT-117131 : Breeze Portfolio - Holdings - News – End 


export const sectorWiseNewsDetailsSuccess = (payload) => {

    return { type: NEWS.GET_SECTOR_WISE_NEWS_DETAILS_SUCCESS, payload };
};

export const sectorWiseNewsDetailsFailure = (payload) => {
    return { type: NEWS.GET_SECTOR_WISE_NEWS_DETAILS_FAILURE, payload };
};



export const FIIDIIMFData = (type, jtenantToken) => async (dispatch) => {
    const objResp = await _FIIDIIMFData(type, jtenantToken);

    if (objResp?.status) {
        if (type === "FII") {
            dispatch(FIIDataSuccess(objResp?.data));
        } else if (type === "DII") {
            dispatch(DIIDataSuccess(objResp?.data));
        } else if (type === "MF") {
            dispatch(MFDataSuccess(objResp?.data));
        }
    } else {
        if (type === "FII") {
            dispatch(FIIDataFailure([]));
        } else if (type === "DII") {
            dispatch(DIIDataFailure([]));
        } else if (type === "MF") {
            dispatch(MFDataFailure([]));
        }
    }
};

export const FIIDataSuccess = (payload) => {

    return { type: NEWS.GET_FII_SUCCESS, payload };
};

export const FIIDataFailure = (payload) => {
    return { type: NEWS.GET_FII_FAILURE, payload };
};

export const DIIDataSuccess = (payload) => {
    return { type: NEWS.GET_DII_SUCCESS, payload };
};

export const DIIDataFailure = (payload) => {
    return { type: NEWS.GET_DII_FAILURE, payload };
};

export const MFDataSuccess = (payload) => {

    return { type: NEWS.GET_MF_SUCCESS, payload };
};

export const MFDataFailure = (payload) => {
    return { type: NEWS.GET_MF_FAILURE, payload };
};


export const bulkBlockDealData = (exchange, dealType, fromDate, toDate, page, pagesize, jtenantToken) => async (dispatch) => {

    const objResp = await _bulkBlockDealData(exchange, dealType, fromDate, toDate, page, pagesize, jtenantToken);
    if (objResp.status) {
        dispatch(bulkBlockDealDataSuccess(objResp.data));
    } else {
        dispatch(bulkBlockDealDataFailure([]));
    }
};

export const bulkBlockDealDataSuccess = (payload) => {

    return { type: NEWS.GET_BULK_BLOCK_DEAL_SUCCESS, payload };
};

export const bulkBlockDealDataFailure = (payload) => {
    return { type: NEWS.GET_BULK_BLOCK_DEAL_FAILURE, payload };
};



export const mergerDemergerData = (fromDate, toDate, jtenantToken) => async (dispatch) => {

    const objResp = await _mergerDemergerData(fromDate, toDate, jtenantToken);
    if (objResp.status) {
        dispatch(mergerDemergerDataSuccess(objResp?.data));
    } else {
        dispatch(mergerDemergerDataFailure([]));
    }
};

export const mergerDemergerDataSuccess = (payload) => {
    return { type: NEWS.GET_MERGER_DEMERGER_SUCCESS, payload };
};

export const mergerDemergerDataFailure = (payload) => {
    return { type: NEWS.GET_MERGER_DEMERGER_FAILURE, payload };
};



export const setDefaultNewsStates = (objLoginSession) => async (dispatch, getState) => {
    dispatch(updateActiveNewsTab(1));
    dispatch(updateAnnouncementType(objLoginSession?.data?.exchanges?.includes('NSE_EQ') ? 'NSE' : objLoginSession?.data?.exchanges?.includes('BSE_EQ') ? 'BSE' : objLoginSession?.data?.exchanges?.includes('NSE_CUR') ? 'NSECDS' : 'NSE'));
    dispatch(updateNewsSearchText(""));
    dispatch(clearannouncementState());
    dispatch(clearNewsState());
    dispatch(updateAnnouncementNewsStatus(''));
};